import { render } from "./ElevatorPitch.vue?vue&type=template&id=4ce0edd4"
import script from "./ElevatorPitch.vue?vue&type=script&lang=js"
export * from "./ElevatorPitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__